import http from './index'

export default {
  /**
   * 获取系统主题配置
   */
  query (params) {
    return http.get('/front/theme', params)
  },
  /**
   * 设置系统主题配置
   */
  set (params) {
    return http.post('/front/theme/save', params)
  },
  /**
   * 获取系统支持的主题
   */
  list (params) {
    return http.get('/front/theme/themeColors', params)
  }
}
